import { render, staticRenderFns } from "./addEmployeeFromPeople.vue?vue&type=template&id=0d3148b6"
import script from "./addEmployeeFromPeople.vue?vue&type=script&lang=js"
export * from "./addEmployeeFromPeople.vue?vue&type=script&lang=js"
import style0 from "./addEmployeeFromPeople.vue?vue&type=style&index=0&id=0d3148b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports